// extracted by mini-css-extract-plugin
export default {"successEdit":"UI_ITOModuleSuccess_successEdit__5L7PW"};